import { render } from "./CartItemsComponent.vue?vue&type=template&id=1a308998&scoped=true"
import script from "./CartItemsComponent.vue?vue&type=script&lang=ts"
export * from "./CartItemsComponent.vue?vue&type=script&lang=ts"

import "./CartItemsComponent.vue?vue&type=style&index=0&id=1a308998&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a308998"

export default script